module.exports = __webpack_public_path__ + "static/media/majorE1.550896d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorE1.wav
// module id = 1fGi
// module chunks = 0